import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "../components/Footer";

export const LegalSection = ({ title, children }) => (
    <section>
        <h2 className="font-display font-semibold tracking-tight text-ink text-xl mb-3">{title}</h2>
        <div className="space-y-3">{children}</div>
    </section>
);

export const LegalLayout = ({ title, eyebrow, testid, children }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-paper" data-testid={testid}>
            <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-hairline">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-[72px] flex items-center justify-between">
                    <Link to="/" data-testid="legal-logo-home" aria-label="Zur Startseite">
                        <img src="/logo-forest.png" alt="Julians Gartenservice" className="h-10 w-auto" />
                    </Link>
                    <Link
                        to="/"
                        data-testid="legal-back-home"
                        className="inline-flex items-center gap-2 text-sm font-semibold text-forest hover:text-leaf transition-colors duration-200"
                    >
                        <ArrowLeft size={15} strokeWidth={2.4} />
                        Zurück zur Startseite
                    </Link>
                </div>
            </header>
            <main className="max-w-3xl mx-auto px-4 sm:px-6 py-16 lg:py-24">
                <p className="font-mono text-xs uppercase tracking-[0.25em] text-leaf font-semibold mb-4">{eyebrow}</p>
                <h1 className="font-display font-bold tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl">{title}</h1>
                <div className="mt-12 space-y-10 text-base text-shade leading-relaxed">{children}</div>
            </main>
            <Footer />
        </div>
    );
};
